import React from 'react';
import { AiOutlineFileSearch, AiOutlineForm } from 'react-icons/ai';
import { Link } from 'react-router-dom';

const StyledButton = ({ children, href }) => (
    <a
        href={href}
        className='text-center bg-principal text-white py-2 rounded-full border-2 border-principal font-semibold mt-4 hover:bg-white hover:text-principal hover:scale-95 transition-all duration-200 ease-out'>
        <AiOutlineForm size={25} className='inline-block mr-2' />
        {children}
    </a>
);

const StyledButton2 = ({ children, to, onClick }) => (
    <Link
        to={to}
        onClick={onClick}
        className='text-center bg-white text-principal py-2 rounded-full border-2 border-principal font-semibold mt-4 hover:bg-principal hover:text-white hover:scale-95 transition-all duration-200 ease-out'
        style={{ textDecoration: 'none', display: 'inline-block' }}>
        <AiOutlineFileSearch size={25} className='inline-block mr-2' />
        {children}
    </Link>
);

const Card = ({ id, image, title, description }) => (
    <div id={id} className='rounded-xl shadow-2xl bg-white w-96'>
        <div className='p-5 flex flex-col'>
            <div className='rounded-xl overflow-hidden h-52'>
                <img src={`${process.env.PUBLIC_URL}/${image}`} alt={id} className='w-full h-full object-cover' />
            </div>
            <h5 className='text-xl md:text-2xl font-semibold pt-3 font-mukta text-principal cursor-pointer'>{title}</h5>
            <p className='text-slate-500 text-sm pt-2 font-mukta'>{description}</p>
            <StyledButton2 to={{
                pathname: `/${title}`,
                state: { title: title }}}>
                Requisitos
            </StyledButton2>
        </div>
    </div>
);

const Card2 = ({ id, image, title, description }) => (
    <div id={id} className='rounded-xl shadow-2xl bg-white w-96'>
        <div className='p-5 flex flex-col'>
            <div className='rounded-xl overflow-hidden h-52'>
                <img src={`${process.env.PUBLIC_URL}/${image}`} alt={id} className='w-full h-full object-cover' />
            </div>
            <h5 className='text-xl md:text-2xl font-semibold pt-3 font-mukta text-principal cursor-pointer'>{title}</h5>
            <p className='text-slate-500 text-sm pt-2 font-mukta'>{description}</p>
            <StyledButton href={`https://wa.me/+573104032213?text=Hola,%20quiero%20solicitar%20información%20sobre%20${title}...`} target="_blank" rel="noopener noreferrer">
                Solicitar
            </StyledButton>
        </div>
    </div>
);

const Menu = () => {
    return (
        <div>

            <h1 className='font-mukta font-semibold text-principal text-center text-3xl pt-5'>
                Servicios Notariales
            </h1>

            <div className='flex items-center justify-center container mx-auto pt-5'>
                
                <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-12'>

                    {/* Card 1: Sucesiones */}
                    <Card id='sucesiones' image='sucesiones.jpg' title='Sucesiones' description='Solicita diferentes sucesiones' />
                    {/* Card 2: Divorcios */}
                    <Card id='divorcios' image='divorcios.jpg' title='Divorcios' description='Solicita diferentes divorcios' />
                    {/* Card 3: Contratos de compraventa */}
                    <Card2 id='contratos de compraventa' image='contrato-compraventa.png' title='Contratos de compraventa' description='Solicita diferentes contratos de compraventa' />
                    {/* Card 4: Contratos de arrendamiento */}
                    <Card2 id='contratos de arrendamiento' image='contrato-arrendamiento.png' title='Contratos de arrendamiento' description='Solicita diferentes contratos de arrendamiento' />
                    {/* Card 5: Escrituras */}
                    <Card2 id='escrituras' image='escrituras.jpg' title='Escrituras' description='Solicita diferentes escrituras' />
                    {/* Card 6: Fideicomisos */}
                    <Card2 id='fideicomisos' image='fideicomisos.jpg' title='Fideicomisos' description='Solicita diferentes fideicomisos' />
                    {/* Card 7: Apostillas */}
                    <Card2 id='apostillas' image='apostillas.jpg' title='Apostillas' description='Solicita diferentes apostillas' />
                    {/* Card 8: Certificados de tradiciónes */}
                    <Card2 id='certificados de tradición' image='certificados-tradicion.jpg' title='Certificados de tradición' description='Solicita diferentes certificados de tradición' />
                    {/* Card 9: Desistimiento */}
                    <Card2 id='desistimientos' image='desistimiento.png' title='Desistimiento' description='Solicita diferentes desistimientos' />
                    {/* Card 10: Expedición de Registros */}
                    <Card2 id='expedicion de registros' image='expedicion-registros.jpeg' title='Expedición de Registros' description='Solicita diferentes expediciones de registros' />
                    {/* Card 11: Liquidaciones */}
                    <Card2 id='liquidaciones' image='liquidaciones.png' title='Liquidaciones' description='Solicita diferentes liquidaciones' />
                    {/* Card 12: Poderes */}
                    <Card2 id='poderes' image='poderes.png' title='Poderes' description='Solicita diferentes poderes' />
                    {/* Card 13: Registros Digitales */}
                    <Card2 id='registros digitales' image='registros-digitales.jpg' title='Registros Digitales' description='Solicita diferentes registros digitales' />
                    {/* Card 14: Acuerdo de voluntades */}
                    <Card2 id='acuerdo de voluntades' image='acuerdo-voluntades.jpg' title='Acuerdo de voluntades' description='Solicita diferentes acuerdos de voluntades' />
                    
                </div>
            </div>
        </div>
    );
};

export default Menu;